import writeXlsxFile, { type Sheet } from 'write-excel-file/browser';

import { HEADERS, HELP } from './columns';

// Plantilla de la migración (spec 2026-10-14 §2 D5): hoja "Documentos" solo con los
// encabezados (una fila de ejemplo se importaría por error) y hoja "Instrucciones" con
// qué va en cada columna.

const FILE_NAME = 'Plantilla migracion QMS.xlsx';

export function templateSheets(): Sheet<Blob>[] {
  const header = HEADERS.map((h) => ({ value: h, fontWeight: 'bold' as const }));
  const help = [
    [
      { value: 'Columna', fontWeight: 'bold' as const },
      { value: 'Qué va', fontWeight: 'bold' as const },
    ],
    ...HEADERS.map((h) => [{ value: h }, { value: HELP[h] ?? '' }]),
  ];
  return [
    {
      sheet: 'Documentos',
      data: [header],
      columns: HEADERS.map(() => ({ width: 22 })),
      stickyRowsCount: 1,
    },
    { sheet: 'Instrucciones', data: help, columns: [{ width: 28 }, { width: 100 }] },
  ];
}

export async function downloadTemplate(): Promise<void> {
  await writeXlsxFile(templateSheets()).toFile(FILE_NAME);
}
